import * as React from "react";
const SvgTourInfo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M5.368 6.39c1.82 0 3.297-1.43 3.297-3.195S7.189 0 5.368 0c-1.82 0-3.297 1.43-3.297 3.195S3.547 6.39 5.368 6.39M8.95 21.028h-.512V9.734a.6.6 0 0 0-.617-.594H1.788S0 9.188 0 10.626s1.788 1.486 1.788 1.486H2.3v8.916h-.512S0 21.076 0 22.514 1.788 24 1.788 24h7.156s1.788-.048 1.788-1.486-1.782-1.486-1.782-1.486"
    />
  </svg>
);
export default SvgTourInfo;
